<ng-template #defaultTabButtons let-c="close" let-d="dismiss">

    <div class="backgroundTable text-white" ngbAutofocus>

        <div class=" mx-5 ">
            <div class="row my-2">
              <div class="col-9 align-self-center p-2 bd-highlight ">Información</div>
    
              <div class="col-3 d-flex flex-row-reverse bd-highlight p-2 "><button type="button" ngbAutofocus aria-label="Close"  (click)="d('Cross click')" class="btn btn-outline-danger "><i class="fa-solid fa-xmark fa-xl"></i></button></div>
            </div>
          </div>
        <div class="componente-importantes-from  componente-importantes-from-popup">

            <div class="container px-5 pb-5">
                <div class="backgroundTable">

                    <div class="row">
                        <div class="col-6 filterDatatable">
                            <div class="col-md-6 text-left ms-4 mt-3">
                                Cierre Ventas (Nuevo + Ext)
                            </div>
                        </div>
                    </div>

                    <table *ngIf="listPayToday != null && listPayToday.length != 0" datatable [dtOptions]="dtOptions"
                        class="componente-importantes componente-importantes-from-popup">

                        <ng-container *ngIf="listPayToday != null &&  listPayToday.length == 0">
                            <div class="text-center text-white">
                                <h2 class="text-white px-5 mt-5">Sin Registro</h2>
                                <i class="fa-solid fa-face-sad-cry fa-5x my-3"></i>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="listPayToday.length != 0">
                            <thead>
                                <tr>
                                    <th class="text-white text-center">Fecha creacion de pago</th>
                                    <th class="text-white text-center">Fecha proyecto o anexo</th>
                                    <th class="text-white text-center">Cliente</th>
                                    <th class="text-white text-center">Detalle</th>
                                    <th class="text-white text-center">Monto</th>
                                    <th class="text-white text-center">Conversion</th>
                                    <th class="text-white text-center">Monto Convertido</th>
                                    <th class="text-white text-center">Fecha programacion de pago</th>
                                    <th class="text-white text-center">Fecha pago</th>
                                    <th class="text-white text-center">Estado</th>
                            </thead>

                            <tbody>
                                <tr *ngFor="let item of listPayToday">
                                    <td class="text-center">{{item.info_year_info}}</td>
                                    <td class="text-center">{{item.info_day_ext_info}}</td>
                                    <td class="text-center">{{item.clientName}}</td>
                                    <td class="text-center">{{item.title}}</td>
                                    <td class="text-center">{{item.money}} {{item.pay_amount}}</td>
                                    <td class="text-center">{{item.conversion_payment}}</td>
                                    <td class="text-center">{{item.conversion_total}}</td>
                                    <td class="text-center">{{item.info_day_info}}</td>
                                    <td class="text-center">{{item.pay_end_info}}</td>
                                    <td >
                                        <div class="p-2 bd-highlight d-flex flex-column">
                                            <span *ngIf="item.status == 2"
                                              class="badge rounded-pill text-bg-programado p-2" style="font-size: 12px;">PROGRAMADO</span>
                                            <span *ngIf="item.status == 3"
                                              class="badge rounded-pill text-bg-pagado p-2 " style="font-size: 12px;">PAGADO</span>
                                            <span *ngIf="item.status == 4"
                                              class="badge rounded-pill text-bg-anulado p-2 " style="font-size: 12px;">ANULADO</span>
                                            <span *ngIf="item.status == 5"
                                              class="badge rounded-pill text-bg-desc p-2 " style="font-size: 12px;">PENDIENTE</span>
                                            <span *ngIf="item.status == 6"
                                              class="badge rounded-pill text-bg-pendiente p-2 " style="font-size: 12px;">DESCUENTO</span>
                                            <span *ngIf="item.status != 2 && item.status != 3 && item.status != 4 && item.status != 5 && item.status != 6"
                                              class="badge rounded-pill text-bg-creado p-2 " style="font-size: 12px;">CREADO</span>
                                        </div>
                    
                                    </td>
                                </tr>
                            </tbody>
                        </ng-container>
                    </table>

                </div>
            </div>


            <div class="container px-5 pb-5">
                <div class="backgroundTable">

                    <div class="row">
                        <div class="col-6 filterDatatable">
                            <div class="col-md-6 text-left ms-4 mt-3">
                                <span><i class="fa-solid fa-dollar-sign fa-lg"></i>Backlog</span>
                            </div>
                        </div>
                    </div>

                    <table *ngIf="listPayPast != null && listPayPast.length != 0" datatable [dtOptions]="dtOptions"
                        class="componente-importantes componente-importantes-from-popup">

                        <ng-container *ngIf="listPayPast != null &&  listPayPast.length == 0">
                            <div class="text-center text-white">
                                <h2 class="text-white px-5 mt-5">Sin Registro</h2>
                                <i class="fa-solid fa-face-sad-cry fa-5x my-3"></i>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="listPayPast.length != 0">
                            <thead>
                                <tr>
                                    <th class="text-white text-center">Fecha creacion de pago</th>
                                    <th class="text-white text-center">Fecha proyecto o anexo</th>
                                    <th class="text-white text-center">Cliente</th>
                                    <th class="text-white text-center">Detalle</th>
                                    <th class="text-white text-center">Monto</th>
                                    <th class="text-white text-center">Conversion</th>
                                    <th class="text-white text-center">Monto Convertido</th>
                                    <th class="text-white text-center">Fecha programacion de pago</th>
                                    <th class="text-white text-center">Fecha pago</th>
                                    <th class="text-white text-center">Estado</th>
                            </thead>

                            <tbody>
                                <tr *ngFor="let item of listPayPast">
                                    <td class="text-center">{{item.info_year_info}}</td>
                                    <td class="text-center">{{item.info_day_ext_info}}</td>
                                    <td class="text-center">{{item.clientName}}</td>
                                    <td class="text-center">{{item.title}}</td>
                                    <td class="text-center">{{item.money}} {{item.pay_amount}}</td>
                                    <td class="text-center">{{item.conversion_payment}}</td>
                                    <td class="text-center">{{item.conversion_total}}</td>
                                    <td class="text-center">{{item.info_day_info}}</td>
                                    <td class="text-center">{{item.pay_end_info}}</td>
                                    <td >
                                        <div class="p-2 bd-highlight d-flex flex-column">
                                            <span *ngIf="item.status == 2"
                                              class="badge rounded-pill text-bg-programado p-2" style="font-size: 12px;">PROGRAMADO</span>
                                            <span *ngIf="item.status == 3"
                                              class="badge rounded-pill text-bg-pagado p-2 " style="font-size: 12px;">PAGADO</span>
                                            <span *ngIf="item.status == 4"
                                              class="badge rounded-pill text-bg-anulado p-2 " style="font-size: 12px;">ANULADO</span>
                                            <span *ngIf="item.status == 5"
                                              class="badge rounded-pill text-bg-pendiente p-2 " style="font-size: 12px;">PENDIENTE</span>
                                             <span *ngIf="item.status == 6"
                                              class="badge rounded-pill text-bg-desc p-2 " style="font-size: 12px;">DESCUENTO</span>
                                            <span *ngIf="item.status != 2 && item.status != 3 && item.status != 4 && item.status != 5 && item.status != 6"
                                              class="badge rounded-pill text-bg-creado p-2 " style="font-size: 12px;">CREADO</span>
                                        </div>
                    
                                    </td>
                                </tr>
                            </tbody>
                        </ng-container>
                    </table>

                </div>
            </div>

        </div>
    </div>

</ng-template>